import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./StandardLayout.scss";
import { LeftOutlined } from "@ant-design/icons";
import { Layout } from "antd";
import { useState } from "react";
import { TopBar } from "../../components/Topbar/Topbar";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Button } from "../../components/Button/Button";
import { SideMenuRoute } from "../../components/SideMenu/SideMenuRoute";
import { EAppEnv } from "@timeedit/types/lib/enums/appEnv.enum";
const { Sider, Content } = Layout;
/**
 * @description Find navigation item by path
 * @param items {TNavigation[]} - navigation items
 * @param targetPath {string} - target path
 */
const findNavigationItemByPath = (items, targetPath) => {
    for (const item of items) {
        if (item.path === targetPath)
            return item;
        const foundItem = findNavigationItemByPath(item.subItems
            ? [...item.subItems, ...(item.dropdown || [])]
            : item.dropdown || [], targetPath);
        if (foundItem)
            return foundItem;
    }
    return null;
};
/**
 * @description Dynamic component for rendering route components
 * @param componentName {string} - name of the component
 * @param componentMap {[key: string]: ComponentType} - map of components
 */
export const generateDynamicComponent = (componentMap, componentName) => {
    const Component = componentMap[componentName];
    return _jsx(Component, {});
};
/**
 * @deprecated Routing should not be handled by the layout component, use StandardLayout instead.
 */
export const StandardLayoutRoute = ({ routerBasename, navigation, currentProduct, user, organization, appEnv = process.env.REACT_APP_TE_APP_ENV || EAppEnv.PRODUCTION, logoutFn, componentMap }) => {
    var _a;
    const [current, setCurrent] = useState(findNavigationItemByPath(navigation, getElementsFromPathName().sideMenuItem) || navigation[0]);
    const [collapsed, setCollapsed] = useState(false);
    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };
    const onClick = (e) => {
        const curr = findNavigationItemByPath(navigation, e.key);
        if (curr)
            setCurrent(curr);
    };
    return (_jsx(Router, { basename: routerBasename, children: _jsxs(Layout, { "data-testid": "standard-layout-wrapper", style: { margin: 0, padding: 0, maxWidth: "none", height: "100vh" }, children: [_jsx(TopBar, { navigation: navigation, onClick: onClick, currentProduct: currentProduct, user: user, organization: organization, appEnv: appEnv, selected: getElementsFromPathName().sideMenuItem, logoutFn: logoutFn, useBuiltInRouter: true }), _jsxs(Layout, { className: "standard-layout-page-wrapper", children: [(current === null || current === void 0 ? void 0 : current.subItems) ? (_jsxs(Sider, { className: "te-sidemenu", trigger: null, collapsible: true, theme: "light", collapsed: collapsed, children: [_jsx(SideMenuRoute, { navigation: (current === null || current === void 0 ? void 0 : current.subItems) || [], isCollapsed: collapsed, selected: current.redirectTo && !getElementsFromPathName().componentPath
                                        ? current.redirectTo
                                        : getElementsFromPathName().componentPath }), _jsx("div", { className: "collapse-button-wrapper", children: _jsx(Button, { className: `collapse-button ${collapsed ? "collapsed" : "expanded"}`, shape: "circle", onClick: toggleCollapsed, children: _jsx(LeftOutlined, {}) }) })] })) : null, _jsx(Content, { "data-testid": "standard-layout-test-content-wrapper", className: "standard-layout-content-wrapper", children: _jsx(Routes, { children: (_a = ((current === null || current === void 0 ? void 0 : current.subItems) || [current])) === null || _a === void 0 ? void 0 : _a.flatMap((item) => generateRoutes(item, componentMap)) }) })] })] }) }));
};
const generateRoutes = ({ component, path, subItems, nestedRoutes }, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
componentMap) => {
    if (subItems) {
        return subItems.flatMap((item) => generateRoutes(item, componentMap));
    }
    if (nestedRoutes) {
        return [
            _jsx(Route, { path: path, element: componentMap
                    ? generateDynamicComponent(componentMap, component)
                    : component, children: nestedRoutes.flatMap((item) => generateRoutes(item, componentMap)) }, path)
        ];
    }
    return [
        _jsx(Route, { path: path, element: componentMap
                ? generateDynamicComponent(componentMap, component)
                : component }, path)
    ];
};
/**
 * @description Splits the pathname and returns different parts of the path as an object
 */
export const getElementsFromPathName = () => {
    const pathElements = window.location.pathname.split("/").filter(Boolean);
    const lastElement = pathElements.at(-1);
    // Match numeric and alphanumeric strings
    const isResourceId = lastElement === null || lastElement === void 0 ? void 0 : lastElement.match(/^(?:\d+|[0-9a-zA-Z]*[0-9]+[a-zA-Z0-9]*)$/);
    // If the last element is a resource id, remove it from the path
    if (isResourceId)
        pathElements.pop();
    return {
        sideMenuItem: pathElements.length > 1
            ? `/${pathElements.slice(0, -1).join("/")}`
            : `/${pathElements[0]}`,
        componentPath: pathElements.length > 1 ? `/${pathElements.join("/")}` : "",
        resourceId: isResourceId ? lastElement : undefined
    };
};
